<div class="app-shell" [class.app-shell--notification-panel-open]="notificationPanelOpen()">
  <cds-header skipTo="#main-content" brand="" name="UCWIP">
    <cds-hamburger [active]="sideNavExpanded()" activeTitle="Close menu" inactiveTitle="Open menu"
      (selected)="toggleSideNav()"></cds-hamburger>

    <div class="app-shell__header-search">
      <cds-search placeholder="Search cases, people, reports…" ariaLabel="Global search" size="lg"
        [value]="globalSearch()" (valueChange)="globalSearch.set($event)"
        (keydown.enter)="navigateToSearch()"></cds-search>
    </div>

    <cds-header-global>
      <cds-header-action class="app-shell__header-role-action" description="Current role"
        [ariaLabel]="headerRoleAriaLabel()" [active]="profilePanelOpen()" [attr.aria-expanded]="profilePanelOpen()"
        aria-controls="profile-panel" (selected)="toggleProfilePanel()">
        <span class="app-shell__header-role-label">{{ activeRoleLabel() }}</span>
      </cds-header-action>

      <cds-header-action description="Notifications" ariaLabel="Notifications, {{ notificationCount() }} unread"
        [active]="notificationPanelOpen()" (selected)="toggleNotificationPanel()">
        <svg cdsIcon="notification" class="app-shell__header-icon" aria-hidden="true"></svg>
        @if (notificationCount() > 0) {
        <span class="app-shell__notification-badge" aria-hidden="true">{{ notificationCount() }}</span>
        }
      </cds-header-action>

      <cds-header-action description="Profile menu" ariaLabel="Profile menu, signed in as {{ profileDisplayName() }}"
        [active]="profilePanelOpen()" (selected)="toggleProfilePanel()">
        <svg cdsIcon="user" class="app-shell__header-icon" aria-hidden="true"></svg>
      </cds-header-action>
    </cds-header-global>
  </cds-header>

  <cds-sidenav [expanded]="sideNavExpanded()" ariaLabel="Side navigation" [useRouter]="true">
    @for (item of navItems(); track item.id) {
    @if (!item.disabled) {
    <cds-sidenav-item [route]="item.route!" [useRouter]="true">
      <svg [cdsIcon]="item.icon" aria-hidden="true"></svg>
      {{ item.label }}
    </cds-sidenav-item>
    } @else {
    <div class="cds--side-nav__item app-shell__nav-soon-item" role="listitem">
      <div class="app-shell__nav-soon-link">
        <div class="cds--side-nav__icon">
          <svg [cdsIcon]="item.icon" aria-hidden="true"></svg>
        </div>
        <span class="cds--side-nav__link-text">{{ item.label }} — Coming soon</span>
      </div>
    </div>
    }
    }
  </cds-sidenav>

  <cds-panel class="app-shell__notification-panel-shell" [expanded]="notificationPanelOpen()"
    [attr.inert]="notificationPanelOpen() ? null : ''" ariaLabel="Notifications">
    <div class="app-shell__panel app-shell__notification-panel app-shell__panel--scroll">
      <header class="app-shell__notification-toolbar">
        <h2 class="app-shell__panel-title">Notifications</h2>
        <div class="app-shell__notification-unread-filter">
          <cds-toggle size="md" label="Show Only Unread" offText="Off" onText="On" [checked]="notificationUnreadOnly()"
            (checkedChange)="onNotificationUnreadOnlyChange($event)" ariaLabel="Show unread"></cds-toggle>
        </div>
      </header>

      <div class="app-shell__panel-body app-shell__notification-feed-scroll"
        (scroll)="onNotificationPanelScroll($event)">
        @if (notificationsLoading()) {
        <p class="app-shell__panel-copy" role="status">Loading notifications…</p>
        } @else if (notificationsError(); as error) {
        <p class="app-shell__panel-copy">{{ error }}</p>
        } @else if (panelNotifications().length === 0) {
        <p class="app-shell__panel-copy">No notifications.</p>
        } @else {
        <ul class="app-shell__notification-feed">
          @for (entry of panelNotifications(); track entry.trackId) {
          <li class="app-shell__notification-feed-item">
            <button type="button" class="app-shell__notification-row"
              [class.app-shell__notification-row--unread]="entry.unread" (click)="openPanelNotification(entry)">
              <div class="app-shell__notification-row-main">
                <div class="app-shell__notification-row-headline">
                  <span class="app-shell__notification-row-title">{{ entry.title }}</span>
                  <time class="app-shell__notification-row-time">
                    {{ entry.at | date: 'MMM d, y, h:mm a' }}
                  </time>
                </div>
                <span class="app-shell__notification-row-subtitle">{{ entry.subtitle }}</span>
                @if (entry.meta) {
                <span class="app-shell__notification-row-meta">{{ entry.meta }}</span>
                }
              </div>
              @if (entry.unread) {
              <span class="app-shell__notification-unread-dot" aria-label="Unread" title="Unread"></span>
              }
            </button>
          </li>
          }
        </ul>
        }
        @if (notificationsLoadingMore()) {
        <p class="app-shell__panel-copy app-shell__notification-loading-more" role="status">
          Loading more…
        </p>
        }
      </div>
    </div>
  </cds-panel>

  <cds-panel id="profile-panel" [expanded]="profilePanelOpen()" [attr.inert]="profilePanelOpen() ? null : ''"
    ariaLabel="Profile and settings">
    <div class="app-shell__panel app-shell__profile-panel app-shell__panel--scroll">
      <div class="app-shell__panel-body app-shell__profile-panel-body">
        <div class="app-shell__profile-hero">
          <h2 class="app-shell__profile-name">{{ profileDisplayName() }}</h2>
          <p class="app-shell__role-indicator">
            <cds-tag type="blue">{{ activeRoleLabel() }}</cds-tag>
          </p>
        </div>

        @if (roleSwitchEnabled()) {
        <section class="app-shell__profile-section app-shell__role-switch">
          <cds-radio-group legend="Switch role" orientation="vertical"
            helperText="Switching roles reloads the dashboard view." [value]="pendingRoleId()"
            (change)="onPendingRoleChange($event)">
            @for (role of roleOptions; track role.id) {
            <cds-radio [value]="role.id" [disabled]="role.status === 'coming-soon'">
              @if (role.status === 'coming-soon') {
              {{ role.label }} — Coming soon
              } @else {
              {{ role.label }}
              }
            </cds-radio>
            }
          </cds-radio-group>
        </section>
        }
        <footer class="app-shell__panel-actions app-shell__profile-footer">
          <button cdsButton="danger--ghost" size="sm" type="button" (click)="logout()">Log out</button>
        </footer>
      </div>
    </div>
  </cds-panel>

  <div class="app-shell__body">
    <main #mainContent id="main-content" class="app-shell__main"
      [class.app-shell__main--sidenav-collapsed]="!sideNavExpanded()" tabindex="-1">
      @if (accessNotice.message(); as accessMessage) {
      <div class="app-shell__access-notice" role="status" aria-live="polite">
        <cds-inline-notification [notificationObj]="{
              type: 'info',
              title: 'Access restricted',
              message: accessMessage,
              lowContrast: true,
            }" (close)="accessNotice.dismiss()"></cds-inline-notification>
      </div>
      }
      <ng-content />
    </main>
  </div>

  <cds-modal class="session-expiry-modal" size="sm" [open]="sessionTimer.warningOpen()"
    ariaLabel="Session expiring soon">
    <cds-modal-header [showCloseButton]="false">
      <p cdsModalHeaderHeading class="session-modal-heading">Your Session Is About to Expire</p>
    </cds-modal-header>
    <section cdsModalContent>
      <p class="session-modal-content">
        For state security, your session will automatically expire in <strong>60 seconds</strong> due to inactivity.
        Extend your session or log out now.
      </p>
    </section>
    <cds-modal-footer>
      <button cdsButton="danger--ghost" type="button" (click)="logout()">Log out</button>
      <button cdsButton="primary" type="button" (click)="extendSession()">Extend session</button>
    </cds-modal-footer>
  </cds-modal>
</div>